<!--
  @author  yuanchaoxi<ycx@sxw.cn>
  @date    2019/3/14
  @description  AreaSelect组件
-->

<template>
  <div class="area-select-root">
    <a-select size="large" style="width: 120px; margin-right: 10px;" placeholder="请选择省份" @change="provinceChange"  v-model="province.code" :disabled="5>canChangeCount">
      <a-select-option :value="item.code" v-for="item in provinces">{{item.name}}</a-select-option>
    </a-select>
    <a-select size="large" style="width: 120px; margin-right: 10px;" placeholder="请选择城市" @change="cityChange" v-model="city.code" :disabled="4>canChangeCount">
      <a-select-option :value="item.code" v-for="item in citys">{{item.name}}</a-select-option>
    </a-select>
    <a-select size="large" style="width: 120px; margin-right: 10px;" placeholder="请选择区县" @change="areaChange" v-model="area.code" :disabled="3>canChangeCount">
      <a-select-option :value="item.code" v-for="item in areas">{{item.name}}</a-select-option>
    </a-select>
    <a-select v-show="showStreet" size="large" style="width: 120px; margin-right: 10px;" placeholder="请选择街道" @change="streetChange" v-model="street.code" :disabled="2>canChangeCount">
      <a-select-option :value="item.code" v-for="item in streets">{{item.name}}</a-select-option>
    </a-select>

    <a-select class="village" v-show="showCommunity && !!villages && villages.length>0" size="large" style="width: 200px; margin-right: 10px;" placeholder="请选择社区" @change="villageChange" v-model="village.code">
      <a-select-option :value="item.code" v-for="item in villages">{{item.name}}</a-select-option>
    </a-select>
    <br/>
    <a-input v-show="showDetail" style="width: 380px;margin-left: 12.5%;margin-top:5px" size="large" v-model="detail" placeholder="小区名称或详细地址（精确到门牌号）" :disabled="1 > canChangeCount" />
  </div>
</template>

<script>
  import config from '../../../../config/index';
	export default {
		name: 'AreaSelect',
		data() {
			return {
			  province:{code:undefined,name:undefined},
        city:{code:undefined,name:undefined},
        area:{code:undefined,name:undefined},
        street:{code:undefined,name:undefined},
        village:{code:undefined,name:undefined},
        detail:undefined,


        // 城市
        citys:[],
        // 区县
        areas:[],
        // 街道
        streets:[],
        // 社区
        villages:[]
      };
		},
    props:{

		  provinces:Array,
      // 龙泉的街道社区
      lqStreets:Array,
      showDetail:{
        type:Boolean,
        default:true
      },
      showStreet:{
        type:Boolean,
        default:false
      },
      showCommunity:{
        type:Boolean,
        default:false
      },
      // 可变更的个数，从后往前，包括detail框
      canChangeCount:{
        type:Number,
        default:5
      },
      // 下拉输入框的宽度
      inputWidth:{
        type:Number,
        default:120
      }
    },
		components: {},
		
		created() {
		},
		
		methods: {
      provinceChange(code){
        this.province.code = code;
        console.log(this.province.code);
        for(let item of this.provinces){
          if(item.code===this.province.code){
            this.province.name = item.name;
            this.citys = item.children;
            break;
          }
        }
        console.log(this.province);

        // 重置
        this.areas = [];
        this.city={code:undefined,name:undefined},
        this.area={code:undefined,name:undefined};

      },

      cityChange(code){

        // 重置
        this.area={code:undefined,name:undefined};
        this.areas = [];
        this.village = {code:undefined,name:undefined};
        this.villages = [];
        this.street = {code:undefined,name:undefined};
        this.streets = [];


        this.city.code=code;

        for(let item of this.citys){
          if(item.code===this.city.code){
            this.city.name = item.name;
            this.areas = item.children;
            break;
          }
        }
        console.log(this.city,33333);


        //this.detail=undefined;
      },

      areaChange(code){
        this.village = {code:undefined,name:undefined};
        this.villages = [];
        this.street = {code:undefined,name:undefined};
        this.streets = [];

        this.area.code = code;
        for(let item of this.areas){
          if(item.code===this.area.code){
            this.area.name = item.name;
            this.streets = item.children;
            if(item.code===config.web.areaId)
              this.streets=this.lqStreets;//[{"code":"510112001","name":"龙泉街道","children":[{"code":"2019001","name":"滨河花园社区"},{"code":"2019002","name":"商业街社区"},{"code":"2019003","name":"长柏路社区"},{"code":"2019004","name":"百工堰社区"},{"code":"2019005","name":"公园路社区"},{"code":"2019006","name":"广场社区"},{"code":"2019007","name":"万源路社区"},{"code":"2019008","name":"平江路社区"},{"code":"2019009","name":"明江路社区"},{"code":"2019010","name":"星光社区"},{"code":"2019011","name":"芦溪河社区"},{"code":"2019012","name":"红咏社区"},{"code":"2019013","name":"驿河社区"},{"code":"2019014","name":"聚和社区"},{"code":"2019015","name":"顶佛寺村"},{"code":"2019016","name":"平安村"},{"code":"2019017","name":"崇德社区"},{"code":"2019018","name":"龙都社区"},{"code":"2019019","name":"驿都路社区"},{"code":"2019020","name":"接龙社区"},{"code":"2019021","name":"界牌社区"},{"code":"2019022","name":"北泉路社区"},{"code":"2019023","name":"书房村"},{"code":"2019024","name":"书南社区"},{"code":"2019025","name":"怡新社区"},{"code":"2019026","name":"利民社区"},{"code":"2019027","name":"保平社区"},{"code":"2019028","name":"龙平社区"},{"code":"2019029","name":"保安社区"},{"code":"2019030","name":"魏家街社区"},{"code":"2019031","name":"合龙社区"}]},{"code":"510112002","name":"大面街道","children":[{"code":"2019101","name":"龙锦苑社区"},{"code":"2019102","name":"民乐社区"},{"code":"2019103","name":"五星社区"},{"code":"2019104","name":"天鹅湖村"},{"code":"2019105","name":"青台山村"},{"code":"2019106","name":"蒲草村"},{"code":"2019107","name":"龙华社区"},{"code":"2019108","name":"龙安社区"},{"code":"2019109","name":"洪河村"},{"code":"2019110","name":"师大社区"},{"code":"2019111","name":"陵川社区"},{"code":"2019112","name":"洪柳社区"},{"code":"2019113","name":"好日子社区"},{"code":"2019114","name":"东洪社区"},{"code":"2019115","name":"玉石社区"},{"code":"2019116","name":"分水村"}]},{"code":"510112003","name":"十陵街道","children":[{"code":"2019401","name":"天兴社区"},{"code":"2019402","name":"华川社区"},{"code":"2019403","name":"江华社区"},{"code":"2019404","name":"宁江社区"},{"code":"2019405","name":"石灵社区"},{"code":"2019406","name":"大梁村"},{"code":"2019407","name":"青龙村"},{"code":"2019408","name":"千弓村"},{"code":"2019409","name":"太平村"},{"code":"2019410","name":"来龙村"},{"code":"2019411","name":"友谊社区"},{"code":"2019412","name":"和平社区"},{"code":"2019413","name":"双龙社区"}]},{"code":"510112004","name":"同安街道","children":[]},{"code":"510112109","name":"柏合镇","children":[]},{"code":"510112102","name":"洛带镇","children":[]},{"code":"510112104","name":"西河镇","children":[{"code":"2019201","name":"滨西社区"},{"code":"2019202","name":"上游社区"},{"code":"2019203","name":"卫星村"},{"code":"2019204","name":"两河村"},{"code":"2019205","name":"跃进社区"},{"code":"2019206","name":"东风村"},{"code":"2019207","name":"龙井村"},{"code":"2019208","name":"鹿角社区"},{"code":"2019209","name":"黄连村"},{"code":"2019210","name":"大龙村"},{"code":"2019211","name":"阙家村"},{"code":"2019212","name":"天平村"}]},{"code":"510112111","name":"黄土镇","children":[]},{"code":"510112108","name":"洪安镇","children":[]},{"code":"510112115","name":"山泉镇","children":[]},{"code":"510112110","name":"茶店镇","children":[]},{"code":"510112200","name":"万兴乡","children":[]}];
            // 51 四川省 5101 成都市 510112 龙泉驿区
            break;
          }
        }
        console.log(this.area,33333);

        if(!this.showStreet)
          this.$emit('selectEnd',this.getData());
      },
      streetChange(code){
        this.village = {code:undefined,name:undefined};
        this.villages = [];

        this.street.code = code;
        for(let item of this.streets){
          if(item.code===this.street.code){
            this.street.name = item.name;
            this.villages = item.children;
            break;
          }
        }
        console.log(this.street,33333);

        this.$emit('streetChange',this.getData());
        if(!this.villages||this.villages.length===0)
          this.$emit('selectEnd',this.getData());
      },

      villageChange(code){
        this.village.code = code;
        for(let item of this.villages){
          if(item.code===this.village.code){
            this.village.name = item.name;
            break;
          }
        }
        console.log(this.village,33333);
        //this.village={code:undefined,name:undefined};

        this.$emit('villageChange',this.getData());
        this.$emit('selectEnd',this.getData());
      },

      // 判断控件是否显示了社区的选择框
      hasVillages(){
        return (!!this.villages && this.villages.length>0);
      },

      getData(){
        return {
          province:this.province,
          city:this.city,
          area:this.area,
          street:this.street,
          village:this.village,
          detail:this.detail,
          hasVillages:this.hasVillages()
        }
      },

      setData(data){
        this.province.code=data.province.code||undefined;
        this.province.name=data.province.name||undefined;

        this.city.code=data.city.code||undefined;
        this.city.name=data.city.name||undefined;

        this.area.code=data.area.code||undefined;
        this.area.name=data.area.name||undefined;

        this.street.code=data.street.code||undefined;
        this.street.name=data.street.name||undefined;

        this.village.code=data.village?data.village.code:undefined;
        this.village.name=data.village?data.village.name:undefined;

        this.detail=data.detail||undefined;


        for(let item of this.provinces){
          if(item.code===this.province.code){
            this.province.name = item.name;
            this.citys = item.children;
            break;
          }
        }

        for(let item of this.citys){
          if(item.code===this.city.code){
            this.city.name = item.name;
            this.areas = item.children;
            break;
          }
        }
        for(let item of this.areas){
          if(item.code===this.area.code){
            this.area.name = item.name;
            this.streets = item.children;
            if(item.code===config.web.areaId)
              this.streets=this.lqStreets;//[{"code":"510112001","name":"龙泉街道","children":[{"code":"2019001","name":"滨河花园社区"},{"code":"2019002","name":"商业街社区"},{"code":"2019003","name":"长柏路社区"},{"code":"2019004","name":"百工堰社区"},{"code":"2019005","name":"公园路社区"},{"code":"2019006","name":"广场社区"},{"code":"2019007","name":"万源路社区"},{"code":"2019008","name":"平江路社区"},{"code":"2019009","name":"明江路社区"},{"code":"2019010","name":"星光社区"},{"code":"2019011","name":"芦溪河社区"},{"code":"2019012","name":"红咏社区"},{"code":"2019013","name":"驿河社区"},{"code":"2019014","name":"聚和社区"},{"code":"2019015","name":"顶佛寺村"},{"code":"2019016","name":"平安村"},{"code":"2019017","name":"崇德社区"},{"code":"2019018","name":"龙都社区"},{"code":"2019019","name":"驿都路社区"},{"code":"2019020","name":"接龙社区"},{"code":"2019021","name":"界牌社区"},{"code":"2019022","name":"北泉路社区"},{"code":"2019023","name":"书房村"},{"code":"2019024","name":"书南社区"},{"code":"2019025","name":"怡新社区"},{"code":"2019026","name":"利民社区"},{"code":"2019027","name":"保平社区"},{"code":"2019028","name":"龙平社区"},{"code":"2019029","name":"保安社区"},{"code":"2019030","name":"魏家街社区"},{"code":"2019031","name":"合龙社区"}]},{"code":"510112002","name":"大面街道","children":[{"code":"2019101","name":"龙锦苑社区"},{"code":"2019102","name":"民乐社区"},{"code":"2019103","name":"五星社区"},{"code":"2019104","name":"天鹅湖村"},{"code":"2019105","name":"青台山村"},{"code":"2019106","name":"蒲草村"},{"code":"2019107","name":"龙华社区"},{"code":"2019108","name":"龙安社区"},{"code":"2019109","name":"洪河村"},{"code":"2019110","name":"师大社区"},{"code":"2019111","name":"陵川社区"},{"code":"2019112","name":"洪柳社区"},{"code":"2019113","name":"好日子社区"},{"code":"2019114","name":"东洪社区"},{"code":"2019115","name":"玉石社区"},{"code":"2019116","name":"分水村"}]},{"code":"510112003","name":"十陵街道","children":[{"code":"2019401","name":"天兴社区"},{"code":"2019402","name":"华川社区"},{"code":"2019403","name":"江华社区"},{"code":"2019404","name":"宁江社区"},{"code":"2019405","name":"石灵社区"},{"code":"2019406","name":"大梁村"},{"code":"2019407","name":"青龙村"},{"code":"2019408","name":"千弓村"},{"code":"2019409","name":"太平村"},{"code":"2019410","name":"来龙村"},{"code":"2019411","name":"友谊社区"},{"code":"2019412","name":"和平社区"},{"code":"2019413","name":"双龙社区"}]},{"code":"510112004","name":"同安街道","children":[]},{"code":"510112109","name":"柏合镇","children":[]},{"code":"510112102","name":"洛带镇","children":[]},{"code":"510112104","name":"西河镇","children":[{"code":"2019201","name":"滨西社区"},{"code":"2019202","name":"上游社区"},{"code":"2019203","name":"卫星村"},{"code":"2019204","name":"两河村"},{"code":"2019205","name":"跃进社区"},{"code":"2019206","name":"东风村"},{"code":"2019207","name":"龙井村"},{"code":"2019208","name":"鹿角社区"},{"code":"2019209","name":"黄连村"},{"code":"2019210","name":"大龙村"},{"code":"2019211","name":"阙家村"},{"code":"2019212","name":"天平村"}]},{"code":"510112111","name":"黄土镇","children":[]},{"code":"510112108","name":"洪安镇","children":[]},{"code":"510112115","name":"山泉镇","children":[]},{"code":"510112110","name":"茶店镇","children":[]},{"code":"510112200","name":"万兴乡","children":[]}];
            break;
          }
        }
        for(let item of this.streets){
          if(item.code===this.street.code){
            this.street.name = item.name;
            this.villages = item.children;
            break;
          }
        }

      }
    }
	};
</script>

<style lang="stylus" scoped>
  .area-select-root{
    display inline
  }
</style>